import React, { createContext, useContext } from 'react';

var MessagesCTX = createContext({});
MessagesCTX.displayName = "Messages";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function injectMessages(Component) {
  function InjectedMessages(props) {
    return /*#__PURE__*/React.createElement(MessagesCTX.Consumer, null, function (messages) {
      return /*#__PURE__*/React.createElement(Component, _objectSpread2(_objectSpread2({}, props), {}, {
        messages: messages
      }));
    });
  }
  InjectedMessages.displayName = "injectMessages(".concat(Component.displayName || Component.name);
  return InjectedMessages;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _excluded = ["messages"];
function withMessages(Component) {
  var withMessages = function withMessages(_ref) {
    var messages = _ref.messages,
      props = _objectWithoutProperties(_ref, _excluded);
    return /*#__PURE__*/React.createElement(MessagesCTX.Provider, {
      value: messages
    }, /*#__PURE__*/React.createElement(Component, props));
  };
  withMessages.displayName = "withMessages(".concat(Component.displayName || Component.name);
  return withMessages;
}

function useMessages() {
  return useContext(MessagesCTX);
}

export { MessagesCTX, injectMessages, useMessages, withMessages };
//# sourceMappingURL=messages-esm.js.map
